module.exports = __webpack_public_path__ + "img/shuixi06.6e0b95c3.png";